import { accordion } from "./accordion.js";
import { wrapCcwForNoTranslate } from "./reciteme.js";

jQuery(function ($) {
  $(document).ready(function () {
    function translateAfterResults() {
      if (
        typeof Recite !== "undefined" &&
        Recite &&
        Recite.Language &&
        Recite.Language.Translate
      ) {
        const targetLang = window.localStorage.getItem("user_lang") || "en-GB";

        Recite.Language.Translate.translate($("#results")[0], targetLang);
      }
    }

    let resetFiltersButton = $("#filters-reset");

    // Fetch first page of results.
    if ($("#results").length) {
      filterResults(1);
    }

    // Get URL params to prepopulate filters.
    let urlParams = new URLSearchParams(window.location.search);
    let entries = urlParams.entries();
    if (entries) {
      resetFiltersButton.removeAttr("disabled");
      for (let entry of entries) {
        $("#" + entry[0]).val(entry[1]);
      }
    }

    // Form submit.
    $("#filters-form").on("submit", function () {
      filterResults(1); // fetch first page of results
      resetFiltersButton.removeAttr("disabled");
      return false;
    });

    // Reset button.
    resetFiltersButton.on("click", function () {
      $(".filter-inputs__text").val("");
      $(".filter-inputs__date").removeClass("filter-inputs--date-active");
      $(".filter-inputs__select").val(
        $(".filter-inputs__select option:first").val()
      );
      filterResults(1);
      $(this).attr("disabled", true);
    });

    // Pagination.
    $(document).on("click", "[data-filter-page]", function () {
      let paginationNumber = $(this).attr("data-filter-page");
      filterResults(paginationNumber);
    });

    function filterResults(paginationNumber) {
      let filterForm = $("#filters-form");
      let data = filterForm.serializeArray(); // Get form data.
      data.push({ name: "pagination_number", value: paginationNumber });

      $.ajax({
        url: ajax_object.ajax_url,
        data: data, // form data
        type: filterForm.attr("method"), // POST
        beforeSend: function () {
          $(".spinner").addClass("spinner--visible");
        },
        success: function (data) {
          $(".spinner").removeClass("spinner--visible");
          $("#results").html(data); // insert data
          wrapCcwForNoTranslate($("#results")[0]);
          translateAfterResults();

          if (data.includes("accordion")) {
            accordion(); // re-enable accordions (for Faqs)
          }

          // Results summary on top.
          let resultsInfoAppend = $(
            ".pagination-info--appended .pagination-info__text"
          );
          if (resultsInfoAppend) {
            resultsInfoAppend.text(
              $(".pagination-info--ajax .pagination-info__text").text()
            );
          }

          // Adds an entry with filter values to the browser's session history.
          window.history.pushState(data, "");
        },
        /* fail: function (jqXHR, textStatus) {
        },*/
      });
    }

    $(".filter-inputs__filter-button").on("click", function () {
      $(this).parent().toggleClass("filter-inputs--open");
      $(this).attr("aria-expanded", function (i, attr) {
        return attr == "true" ? "false" : "true";
      });
    });

    $(".filter-inputs__date").on("change", function (e) {
      if ($(this).val()) {
        $(this).addClass("filter-inputs--date-active");
      } else {
        $(this).removeClass("filter-inputs--date-active");
      }
    });
  });
});
